import { PortalAuthHttpError } from '../error';
import { PortalApiClient } from '../portalApiClient';

export async function acceptDisclaimer(
  version: number,
  client: PortalApiClient
) {
  try {
    const { data, error, response } = await client.untyped.PUT(
      '/api/v1/users/me/disclaimer',
      {
        body: { disclaimer_version: version },
      }
    );
    if (!response.ok) {
      throw new PortalAuthHttpError(
        (error as { error?: string })?.error ??
          'Updating disclaimer version failed.',
        response.status
      );
    }
    return data;
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
